import { __decorate, __param } from 'tslib';
import { Platform, PlatformModule } from '@angular/cdk/platform';
import { InjectionToken, Inject, PLATFORM_ID, ɵɵdefineInjectable, ɵɵinject, Injectable, EventEmitter, Input, Component, NgModule, ComponentFactoryResolver } from '@angular/core';
import { isPlatformBrowser, DOCUMENT, CommonModule, isPlatformServer } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/cdk/platform';
import * as ɵngcc2 from '@angular/common';

function NgxSmartBannerComponent_div_8_app_star_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "app-star", 10);
} if (rf & 2) {
    const i_r3 = ctx.index;
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("solid", ctx_r1.reviewAverage <= i_r3);
} }
const _c0 = function () { return [0, 1, 2, 3, 4]; };
function NgxSmartBannerComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵtemplate(1, NgxSmartBannerComponent_div_8_app_star_1_Template, 1, 1, "app-star", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpureFunction0(1, _c0));
} }
const _c1 = function (a0) { return { "background-image": a0 }; };
function StarComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(1, "svg", 2);
    ɵngcc0.ɵɵelement(2, "path", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} }
function StarComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "svg", 4);
    ɵngcc0.ɵɵelement(1, "path", 5);
    ɵngcc0.ɵɵelementEnd();
} }
const _c2 = ".smartbanner[_ngcontent-%COMP%]{box-sizing:border-box;text-shadow:none;position:absolute;top:0;left:0;z-index:99999;padding:0 10px;width:100%;height:84px;display:flex;justify-content:space-between;align-items:center;background:#f3f3f3;font-family:Helvetica,sans,sans-serif}.smartbanner__exit[_ngcontent-%COMP%]{position:relative;display:block;margin-right:14px;background-color:#f3f3f3;width:12px;height:12px;border:0;text-align:center}.smartbanner__exit[_ngcontent-%COMP%]::after, .smartbanner__exit[_ngcontent-%COMP%]::before{position:absolute;top:0;width:1px;height:12px;background:#767676;content:\"\"}.smartbanner__exit[_ngcontent-%COMP%]::before{transform:rotate(45deg)}.smartbanner__exit[_ngcontent-%COMP%]::after{transform:rotate(-45deg)}.smartbanner__icon[_ngcontent-%COMP%]{width:64px;height:64px;border-radius:15px;background-size:64px 64px}.smartbanner__info[_ngcontent-%COMP%]{margin-left:8px;display:flex;flex-direction:column;justify-content:space-between;width:45%;height:64px;color:#767676}.smartbanner__info--title[_ngcontent-%COMP%]{font-size:14px;color:#000}.smartbanner__info--rating[_ngcontent-%COMP%]{display:flex;margin:3px 0}.smartbanner__info--author[_ngcontent-%COMP%], .smartbanner__info--price[_ngcontent-%COMP%]{font-size:12px}.smartbanner__button[_ngcontent-%COMP%]{display:block;padding:0 10px;min-width:10%;background:#f3f3f3;color:#1474fc;font-size:14px;font-weight:700;text-align:center;text-decoration:none}.smartbanner__button__label[_ngcontent-%COMP%]{text-align:center}.smartbanner.smartbanner--android[_ngcontent-%COMP%]{background:url(data:image/gif;base64,R0lGODlhCAAIAIABAFVVVf///yH5BAEHAAEALAAAAAAIAAgAAAINRG4XudroGJBRsYcxKAA7) #3d3d3d}.smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__exit[_ngcontent-%COMP%]{margin-right:0;width:18px;height:17px;border-radius:14px;background:#1c1e21;box-shadow:0 1px 2px rgba(0,0,0,.8) inset,0 1px 1px rgba(255,255,255,.3);color:#b1b1b3;font-family:ArialRoundedMTBold,Arial;font-size:20px;line-height:17px;text-shadow:0 1px 1px #000}.smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__exit[_ngcontent-%COMP%]::after, .smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__exit[_ngcontent-%COMP%]::before{top:3px;left:8px;width:2px;height:11px;background:#b1b1b3}.smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__exit[_ngcontent-%COMP%]:active, .smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__exit[_ngcontent-%COMP%]:hover{color:#eee}.smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__icon[_ngcontent-%COMP%]{background-color:transparent;box-shadow:none}.smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__info[_ngcontent-%COMP%]{color:#ccc}.smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__info--title[_ngcontent-%COMP%]{color:#fff;font-weight:700}.smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__button[_ngcontent-%COMP%]{color:#fff;background:#3eacc3;padding:5px 10px;border:2px solid #fff;min-width:12%;font-size:14px;font-weight:700}.smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__button[_ngcontent-%COMP%]:active, .smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__button[_ngcontent-%COMP%]:hover{background:0 0}.smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__button__label[_ngcontent-%COMP%]{display:block;padding:0 10px;background:#42b6c9;background:linear-gradient(to bottom,#42b6c9,#39a9bb);box-shadow:none;line-height:24px;text-align:center;text-transform:none}.smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__button__label[_ngcontent-%COMP%]:active, .smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__button__label[_ngcontent-%COMP%]:hover{background:#2ac7e1}.star-rating[_ngcontent-%COMP%]{font-size:12px;color:#e19620;margin-right:2px}";
let CookieService = class CookieService {
    constructor(platformId, document) {
        this.document = document;
        this.isBrowser = isPlatformBrowser(platformId);
    }
    check(key) {
        if (!this.isBrowser) {
            return false;
        }
        return this.isBrowser && this.document.cookie.includes(key);
    }
    set(key, value, until = null) {
        var _a, _b;
        if (!this.isBrowser) {
            return;
        }
        const untilUTC = (_a = until) === null || _a === void 0 ? void 0 : _a.toUTCString();
        const expires = untilUTC ? `; expires=${((_b = until) === null || _b === void 0 ? void 0 : _b.toUTCString()) || ''}` : '';
        this.document.cookie = `${key}=${value}${expires}; path=/; SameSite=Strict`;
    }
    get(key) {
        var _a;
        if (!this.isBrowser) {
            return '';
        }
        const match = this.document.cookie.match(new RegExp(`(^| )${key}=([^;]+)`));
        return ((_a = match) === null || _a === void 0 ? void 0 : _a[2]) || null;
    }
    deleteAll() {
        if (!this.isBrowser) {
            return;
        }
        this.document.cookie = '';
    }
};
CookieService.ɵfac = function CookieService_Factory(t) { return new (t || CookieService)(ɵngcc0.ɵɵinject(PLATFORM_ID), ɵngcc0.ɵɵinject(DOCUMENT)); };
CookieService.ctorParameters = () => [
    { type: InjectionToken, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
CookieService.ɵprov = ɵɵdefineInjectable({ factory: function CookieService_Factory() { return new CookieService(ɵɵinject(PLATFORM_ID), ɵɵinject(DOCUMENT)); }, token: CookieService, providedIn: "root" });
CookieService = __decorate([ __param(0, Inject(PLATFORM_ID)),
    __param(1, Inject(DOCUMENT))
], CookieService);

let NgxSmartBannerComponent = class NgxSmartBannerComponent {
    constructor(platform, cookieService) {
        this.platform = platform;
        this.cookieService = cookieService;
        this.onClose = new EventEmitter();
        if (this.platform.ANDROID) {
            this.modifier = 'android';
        }
        if (this.platform.IOS) {
            this.modifier = 'ios';
        }
    }
    /**
     * Gets icon
     */
    get icon() {
        var _a, _b, _c, _d;
        if (this.platform.ANDROID) {
            return (_b = (_a = this.settings) === null || _a === void 0 ? void 0 : _a.icon) === null || _b === void 0 ? void 0 : _b.android;
        }
        if (this.platform.IOS) {
            return (_d = (_c = this.settings) === null || _c === void 0 ? void 0 : _c.icon) === null || _d === void 0 ? void 0 : _d.ios;
        }
        return null;
    }
    /**
     * Gets button url
     */
    get buttonUrl() {
        var _a, _b, _c, _d;
        if (this.platform.ANDROID) {
            return (_b = (_a = this.settings) === null || _a === void 0 ? void 0 : _a.buttonUrl) === null || _b === void 0 ? void 0 : _b.android;
        }
        if (this.platform.IOS) {
            return (_d = (_c = this.settings) === null || _c === void 0 ? void 0 : _c.buttonUrl) === null || _d === void 0 ? void 0 : _d.ios;
        }
        return '#';
    }
    /**
     * Gets price suffix
     */
    get priceSuffix() {
        if (this.platform.ANDROID) {
            return this.settings.priceSuffix.android;
        }
        if (this.platform.IOS) {
            return this.settings.priceSuffix.ios;
        }
        return '';
    }
    /**
     * Set cookie to reminder value and destroy component
     */
    exit() {
        this.cookieService.set('smartbanner_closed', '1', this.endDate('exit'));
        this.onClose.emit();
        this.componentRef.destroy();
    }
    /**
     * Set cookie to hidden value and destroy component
     *
     * @author Roy Freij <roy@bsbip.com>
     */
    view() {
        this.cookieService.set('smartbanner_closed', '1', this.endDate('view'));
        this.onClose.emit();
        this.componentRef.destroy();
    }
    /**
     * Gets end date
     */
    endDate(type) {
        const date = new Date();
        if (!this.settings.daysReminder) {
            return null;
        }
        const timeToLive = type === 'exit'
            ? this.settings.daysHidden
            : this.settings.daysReminder;
        date.setDate(date.getDate() + timeToLive);
        return date;
    }
    /**
     * Gets review rating
     *
     * @author Harry Apperloo <harry@bsbip.com>
     */
    get reviewAverage() {
        var _a, _b, _c;
        if (this.platform.ANDROID) {
            return (_a = this.settings) === null || _a === void 0 ? void 0 : _a.rating.android;
        }
        if (this.platform.IOS) {
            return (_c = (_b = this.settings) === null || _b === void 0 ? void 0 : _b.rating) === null || _c === void 0 ? void 0 : _c.ios;
        }
        return 5;
    }
};
NgxSmartBannerComponent.ɵfac = function NgxSmartBannerComponent_Factory(t) { return new (t || NgxSmartBannerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.Platform), ɵngcc0.ɵɵdirectiveInject(CookieService)); };
NgxSmartBannerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxSmartBannerComponent, selectors: [["nc-ngx-smart-banner"]], inputs: { settings: "settings", componentRef: "componentRef" }, decls: 13, vars: 15, consts: [[1, "smartbanner__exit", 3, "click"], [1, "smartbanner__icon", 3, "ngStyle"], [1, "smartbanner__info"], [1, "smartbanner__info--title"], [1, "smartbanner__info--author"], ["class", "smartbanner__info--rating", 4, "ngIf"], [1, "smartbanner__info--price"], ["target", "_blank", "rel", "noopener", 1, "smartbanner__button", 3, "href", "click"], [1, "smartbanner__info--rating"], [3, "solid", 4, "ngFor", "ngForOf"], [3, "solid"]], template: function NgxSmartBannerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div")(1, "button", 0);
        ɵngcc0.ɵɵlistener("click", function NgxSmartBannerComponent_Template_button_click_1_listener() { return ctx.exit(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(2, "div", 1);
        ɵngcc0.ɵɵelementStart(3, "div", 2)(4, "div", 3);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 4);
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, NgxSmartBannerComponent_div_8_Template, 2, 2, "div", 5);
        ɵngcc0.ɵɵelementStart(9, "div", 6);
        ɵngcc0.ɵɵtext(10);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(11, "a", 7);
        ɵngcc0.ɵɵlistener("click", function NgxSmartBannerComponent_Template_a_click_11_listener() { return ctx.view(); });
        ɵngcc0.ɵɵtext(12);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("smartbanner smartbanner--", ctx.modifier, "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("aria-label", ctx.settings.closeLabel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(13, _c1, "url(" + ctx.icon + ")"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.settings.title, " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.settings.author, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.settings.hideRating);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate2(" ", ctx.settings.price, "", ctx.priceSuffix, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("href", ctx.buttonUrl, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵattribute("aria-label", ctx.settings.buttonLabel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.settings.buttonLabel, " ");
    } }, dependencies: function () { return [ɵngcc2.NgForOf, ɵngcc2.NgIf, ɵngcc2.NgStyle, StarComponent]; }, styles: [_c2] });
NgxSmartBannerComponent.ctorParameters = () => [
    { type: Platform },
    { type: CookieService }
];
__decorate([
    Input()
], NgxSmartBannerComponent.prototype, "settings", void 0);
__decorate([
    Input()
], NgxSmartBannerComponent.prototype, "componentRef", void 0);

let StarComponent = class StarComponent {
};
StarComponent.ɵfac = function StarComponent_Factory(t) { return new (t || StarComponent)(); };
StarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: StarComponent, selectors: [["app-star"]], inputs: { solid: "solid" }, decls: 3, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["regular", ""], ["width", "16px", "height", "16px", "viewBox", "0 0 1792 1792", "xmlns", "http://www.w3.org/2000/svg"], ["fill", "orange", "d", "M1201 1004l306-297-422-62-189-382-189 382-422 62 306 297-73 421 378-199 377 199zm527-357q0 22-26 48l-363 354 86 500q1 7 1 20 0 50-41 50-19 0-40-12l-449-236-449 236q-22 12-40 12-21 0-31.5-14.5t-10.5-35.5q0-6 2-20l86-500-364-354q-25-27-25-48 0-37 56-46l502-73 225-455q19-41 49-41t49 41l225 455 502 73q56 9 56 46z"], ["width", "16px", "height", "16px", "xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 576 512", 1, "star-rating"], ["fill", "orange", "d", "M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"]], template: function StarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, StarComponent_ng_container_0_Template, 3, 0, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, StarComponent_ng_template_1_Template, 2, 0, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.solid)("ngIfElse", _r1);
    } }, dependencies: [ɵngcc2.NgIf], styles: [_c2] });
__decorate([
    Input()
], StarComponent.prototype, "solid", void 0);

let NgxSmartBannerModule = class NgxSmartBannerModule {
};
NgxSmartBannerModule.ɵfac = function NgxSmartBannerModule_Factory(t) { return new (t || NgxSmartBannerModule)(); };
NgxSmartBannerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxSmartBannerModule });
NgxSmartBannerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule, PlatformModule] });

var NgxSmartBannerPlatform;
(function (NgxSmartBannerPlatform) {
    NgxSmartBannerPlatform["Android"] = "android";
    NgxSmartBannerPlatform["IOS"] = "ios";
})(NgxSmartBannerPlatform || (NgxSmartBannerPlatform = {}));

let NgxSmartBannerService = class NgxSmartBannerService {
    constructor(platform, componentResolver, platformId, cookieService) {
        this.platform = platform;
        this.componentResolver = componentResolver;
        this.platformId = platformId;
        this.cookieService = cookieService;
        this.smartBanner = null;
        this.onOpen = new EventEmitter();
        this.onClose = new EventEmitter();
        this.isServer = isPlatformServer(this.platformId);
        this.settings = {
            title: 'Smart application',
            author: 'Smartbanner contributors',
            price: 'FREE',
            closeLabel: 'Close',
            buttonLabel: 'VIEW',
            enabledPlatforms: [
                NgxSmartBannerPlatform.Android,
                NgxSmartBannerPlatform.IOS,
            ],
            viewContainerRef: null,
            priceSuffix: {
                ios: ' - On the App Store',
                android: ' - In Google play',
            },
            rating: {
                ios: 2,
                android: 5,
            },
            hideRating: false,
        };
    }
    /**
     * Initializes ngx smart banner service
     *
     * @params settings
     */
    initialize(settings) {
        this.settings = Object.assign(Object.assign({}, this.settings), settings);
        if (!this.settings.viewContainerRef) {
            throw new Error('No view container ref provided');
        }
        if (this.isServer || this.cookieService.check('smartbanner_closed')) {
            return;
        }
        if (!this.platformEnabled) {
            return;
        }
        if (this.smartBanner === null) {
            const componentFactory = this.componentResolver.resolveComponentFactory(NgxSmartBannerComponent);
            const componentRef = this.settings.viewContainerRef.createComponent(componentFactory);
            this.onOpen.emit();
            componentRef.instance.componentRef = componentRef;
            this.smartBanner = componentRef.instance;
            this.onCloseSubscription$ = this.smartBanner.onClose.subscribe(() => {
                this.onClose.emit();
                this.onCloseSubscription$.unsubscribe();
            });
        }
        this.smartBanner.settings = this.settings;
    }
    /**
     * Determine if platform is enabled
     */
    get platformEnabled() {
        console.log(this.settings.enabledPlatforms);
        if (this.platform.ANDROID) {
            return this.settings.enabledPlatforms.includes(NgxSmartBannerPlatform.Android);
        }
        if (this.platform.IOS) {
            return this.settings.enabledPlatforms.includes(NgxSmartBannerPlatform.IOS);
        }
        return false;
    }
};
NgxSmartBannerService.ɵfac = function NgxSmartBannerService_Factory(t) { return new (t || NgxSmartBannerService)(ɵngcc0.ɵɵinject(ɵngcc1.Platform), ɵngcc0.ɵɵinject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵinject(PLATFORM_ID), ɵngcc0.ɵɵinject(CookieService)); };
NgxSmartBannerService.ctorParameters = () => [
    { type: Platform },
    { type: ComponentFactoryResolver },
    { type: String, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: CookieService }
];
NgxSmartBannerService.ɵprov = ɵɵdefineInjectable({ factory: function NgxSmartBannerService_Factory() { return new NgxSmartBannerService(ɵɵinject(Platform), ɵɵinject(ComponentFactoryResolver), ɵɵinject(PLATFORM_ID), ɵɵinject(CookieService)); }, token: NgxSmartBannerService, providedIn: "root" });
NgxSmartBannerService = __decorate([ __param(2, Inject(PLATFORM_ID))
], NgxSmartBannerService);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CookieService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc0.InjectionToken, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxSmartBannerComponent, [{
        type: Component,
        args: [{ selector: 'nc-ngx-smart-banner', template: "<div class=\"smartbanner smartbanner--{{ modifier }}\">\r\n    <button\r\n        (click)=\"exit()\"\r\n        class=\"smartbanner__exit\"\r\n        [attr.aria-label]=\"settings.closeLabel\"\r\n    ></button>\r\n    <div\r\n        class=\"smartbanner__icon\"\r\n        [ngStyle]=\"{ 'background-image': 'url(' + icon + ')' }\"\r\n    ></div>\r\n    <div class=\"smartbanner__info\">\r\n        <div class=\"smartbanner__info--title\">\r\n            {{ settings.title }}\r\n        </div>\r\n        <div class=\"smartbanner__info--author\">\r\n            {{ settings.author }}\r\n        </div>\r\n        <div class=\"smartbanner__info--rating\" *ngIf=\"!settings.hideRating\">\r\n            <app-star\r\n                *ngFor=\"let in of [0, 1, 2, 3, 4]; let i = index\"\r\n                [solid]=\"reviewAverage <= i\"\r\n            ></app-star>\r\n        </div>\r\n        <div class=\"smartbanner__info--price\">\r\n            {{ settings.price }}{{ priceSuffix }}\r\n        </div>\r\n    </div>\r\n    <a\r\n        href=\"{{ buttonUrl }}\"\r\n        target=\"_blank\"\r\n        (click)=\"view()\"\r\n        class=\"smartbanner__button\"\r\n        rel=\"noopener\"\r\n        [attr.aria-label]=\"settings.buttonLabel\"\r\n    >\r\n        {{ settings.buttonLabel }}\r\n    </a>\r\n</div>\r\n", styles: [".smartbanner{box-sizing:border-box;text-shadow:none;position:absolute;top:0;left:0;z-index:99999;padding:0 10px;width:100%;height:84px;display:flex;justify-content:space-between;align-items:center;background:#f3f3f3;font-family:Helvetica,sans,sans-serif}.smartbanner__exit{position:relative;display:block;margin-right:14px;background-color:#f3f3f3;width:12px;height:12px;border:0;text-align:center}.smartbanner__exit::after,.smartbanner__exit::before{position:absolute;top:0;width:1px;height:12px;background:#767676;content:\"\"}.smartbanner__exit::before{transform:rotate(45deg)}.smartbanner__exit::after{transform:rotate(-45deg)}.smartbanner__icon{width:64px;height:64px;border-radius:15px;background-size:64px 64px}.smartbanner__info{margin-left:8px;display:flex;flex-direction:column;justify-content:space-between;width:45%;height:64px;color:#767676}.smartbanner__info--title{font-size:14px;color:#000}.smartbanner__info--rating{display:flex;margin:3px 0}.smartbanner__info--author,.smartbanner__info--price{font-size:12px}.smartbanner__button{display:block;padding:0 10px;min-width:10%;background:#f3f3f3;color:#1474fc;font-size:14px;font-weight:700;text-align:center;text-decoration:none}.smartbanner__button__label{text-align:center}.smartbanner.smartbanner--android{background:url(data:image/gif;base64,R0lGODlhCAAIAIABAFVVVf///yH5BAEHAAEALAAAAAAIAAgAAAINRG4XudroGJBRsYcxKAA7) #3d3d3d}.smartbanner.smartbanner--android .smartbanner__exit{margin-right:0;width:18px;height:17px;border-radius:14px;background:#1c1e21;box-shadow:0 1px 2px rgba(0,0,0,.8) inset,0 1px 1px rgba(255,255,255,.3);color:#b1b1b3;font-family:ArialRoundedMTBold,Arial;font-size:20px;line-height:17px;text-shadow:0 1px 1px #000}.smartbanner.smartbanner--android .smartbanner__exit::after,.smartbanner.smartbanner--android .smartbanner__exit::before{top:3px;left:8px;width:2px;height:11px;background:#b1b1b3}.smartbanner.smartbanner--android .smartbanner__exit:active,.smartbanner.smartbanner--android .smartbanner__exit:hover{color:#eee}.smartbanner.smartbanner--android .smartbanner__icon{background-color:transparent;box-shadow:none}.smartbanner.smartbanner--android .smartbanner__info{color:#ccc}.smartbanner.smartbanner--android .smartbanner__info--title{color:#fff;font-weight:700}.smartbanner.smartbanner--android .smartbanner__button{color:#fff;background:#3eacc3;padding:5px 10px;border:2px solid #fff;min-width:12%;font-size:14px;font-weight:700}.smartbanner.smartbanner--android .smartbanner__button:active,.smartbanner.smartbanner--android .smartbanner__button:hover{background:0 0}.smartbanner.smartbanner--android .smartbanner__button__label{display:block;padding:0 10px;background:#42b6c9;background:linear-gradient(to bottom,#42b6c9,#39a9bb);box-shadow:none;line-height:24px;text-align:center;text-transform:none}.smartbanner.smartbanner--android .smartbanner__button__label:active,.smartbanner.smartbanner--android .smartbanner__button__label:hover{background:#2ac7e1}.star-rating{font-size:12px;color:#e19620;margin-right:2px}"] }]
    }], function () { return [{ type: ɵngcc1.Platform }, { type: CookieService }]; }, { settings: [{
            type: Input
        }], componentRef: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StarComponent, [{
        type: Component,
        args: [{ selector: 'app-star', template: "<ng-container *ngIf=\"solid; else regular\">\r\n    <svg\r\n        width=\"16px\"\r\n        height=\"16px\"\r\n        viewBox=\"0 0 1792 1792\"\r\n        xmlns=\"http://www.w3.org/2000/svg\"\r\n    >\r\n        <path\r\n            fill=\"orange\"\r\n            d=\"M1201 1004l306-297-422-62-189-382-189 382-422 62 306 297-73 421 378-199 377 199zm527-357q0 22-26 48l-363 354 86 500q1 7 1 20 0 50-41 50-19 0-40-12l-449-236-449 236q-22 12-40 12-21 0-31.5-14.5t-10.5-35.5q0-6 2-20l86-500-364-354q-25-27-25-48 0-37 56-46l502-73 225-455q19-41 49-41t49 41l225 455 502 73q56 9 56 46z\"\r\n        />\r\n    </svg>\r\n</ng-container>\r\n<ng-template #regular>\r\n    <svg\r\n        width=\"16px\"\r\n        height=\"16px\"\r\n        class=\"star-rating\"\r\n        xmlns=\"http://www.w3.org/2000/svg\"\r\n        viewBox=\"0 0 576 512\"\r\n    >\r\n        <path\r\n            fill=\"orange\"\r\n            d=\"M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z\"\r\n        />\r\n    </svg>\r\n</ng-template>\r\n", styles: [".smartbanner{box-sizing:border-box;text-shadow:none;position:absolute;top:0;left:0;z-index:99999;padding:0 10px;width:100%;height:84px;display:flex;justify-content:space-between;align-items:center;background:#f3f3f3;font-family:Helvetica,sans,sans-serif}.smartbanner__exit{position:relative;display:block;margin-right:14px;background-color:#f3f3f3;width:12px;height:12px;border:0;text-align:center}.smartbanner__exit::after,.smartbanner__exit::before{position:absolute;top:0;width:1px;height:12px;background:#767676;content:\"\"}.smartbanner__exit::before{transform:rotate(45deg)}.smartbanner__exit::after{transform:rotate(-45deg)}.smartbanner__icon{width:64px;height:64px;border-radius:15px;background-size:64px 64px}.smartbanner__info{margin-left:8px;display:flex;flex-direction:column;justify-content:space-between;width:45%;height:64px;color:#767676}.smartbanner__info--title{font-size:14px;color:#000}.smartbanner__info--rating{display:flex;margin:3px 0}.smartbanner__info--author,.smartbanner__info--price{font-size:12px}.smartbanner__button{display:block;padding:0 10px;min-width:10%;background:#f3f3f3;color:#1474fc;font-size:14px;font-weight:700;text-align:center;text-decoration:none}.smartbanner__button__label{text-align:center}.smartbanner.smartbanner--android{background:url(data:image/gif;base64,R0lGODlhCAAIAIABAFVVVf///yH5BAEHAAEALAAAAAAIAAgAAAINRG4XudroGJBRsYcxKAA7) #3d3d3d}.smartbanner.smartbanner--android .smartbanner__exit{margin-right:0;width:18px;height:17px;border-radius:14px;background:#1c1e21;box-shadow:0 1px 2px rgba(0,0,0,.8) inset,0 1px 1px rgba(255,255,255,.3);color:#b1b1b3;font-family:ArialRoundedMTBold,Arial;font-size:20px;line-height:17px;text-shadow:0 1px 1px #000}.smartbanner.smartbanner--android .smartbanner__exit::after,.smartbanner.smartbanner--android .smartbanner__exit::before{top:3px;left:8px;width:2px;height:11px;background:#b1b1b3}.smartbanner.smartbanner--android .smartbanner__exit:active,.smartbanner.smartbanner--android .smartbanner__exit:hover{color:#eee}.smartbanner.smartbanner--android .smartbanner__icon{background-color:transparent;box-shadow:none}.smartbanner.smartbanner--android .smartbanner__info{color:#ccc}.smartbanner.smartbanner--android .smartbanner__info--title{color:#fff;font-weight:700}.smartbanner.smartbanner--android .smartbanner__button{color:#fff;background:#3eacc3;padding:5px 10px;border:2px solid #fff;min-width:12%;font-size:14px;font-weight:700}.smartbanner.smartbanner--android .smartbanner__button:active,.smartbanner.smartbanner--android .smartbanner__button:hover{background:0 0}.smartbanner.smartbanner--android .smartbanner__button__label{display:block;padding:0 10px;background:#42b6c9;background:linear-gradient(to bottom,#42b6c9,#39a9bb);box-shadow:none;line-height:24px;text-align:center;text-transform:none}.smartbanner.smartbanner--android .smartbanner__button__label:active,.smartbanner.smartbanner--android .smartbanner__button__label:hover{background:#2ac7e1}.star-rating{font-size:12px;color:#e19620;margin-right:2px}"] }]
    }], null, { solid: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxSmartBannerModule, [{
        type: NgModule,
        args: [{
                declarations: [NgxSmartBannerComponent, StarComponent],
                imports: [CommonModule, PlatformModule],
                exports: [NgxSmartBannerComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxSmartBannerModule, { declarations: function () { return [NgxSmartBannerComponent, StarComponent]; }, imports: function () { return [CommonModule, PlatformModule]; }, exports: function () { return [NgxSmartBannerComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxSmartBannerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.Platform }, { type: ɵngcc0.ComponentFactoryResolver }, { type: String, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }, { type: CookieService }]; }, null); })();

/*
 * Public API Surface of ngx-smart-banner
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxSmartBannerComponent, NgxSmartBannerModule, NgxSmartBannerPlatform, NgxSmartBannerService, CookieService as ɵa, StarComponent as ɵb };

